import axios from 'axios';
const state = () => ({
 selectedSection : 0,
 openSectionIndex: null,
 clonnedSection: false,
 sectionsUpdate: [],
 sections: [],
 race: null,
 classes: [],
 activeMessageConfirmation: false,
 nextUrl: ''
});

const getters = {
    getSelectedSection: (state) => state.selectedSection,
    getOpenSectionIndex: (state) => state.openSectionIndex,
    getClonnedSection: (state) => state.clonnedSection,
    getSectionsUpdate: (state) => state.sectionsUpdate,
    getSections: (state) => state.sections,
    getRaceSections: (state) => state.race,
    getClasses: (state) => state.classes,
    getActiveMessageConfirmation: (state) => state.activeMessageConfirmation,
    getNextUrl: (state) => state.nextUrl
};

const mutations = {
 updateSectionEditor(state, data) {
  state.selectedSection = data;
 },
 updateOpenSectionIndex(state, data) {
  state.openSectionIndex = data;
  state.clonnedSection = false;
 },
 updateClonnedSection(state) {
  state.clonnedSection = true;
 },
 setSections(state,data) {
  state.sections = data
 },
 setRace(state,data) {
    state.race = data;
 },
 setClasses(state,data) {
    state.classes = data;
 },
 setSectionsUpdate(state,data) {
    state.sectionsUpdate = data;
 },
 setActiveMessageConfirmation(state, data) {
    state.activeMessageConfirmation = data
 },
 setNextUrl(state, data) {
    state.nextUrl = data
 }
}

const actions = {
    async setNameAction(context, eventname) {   
        context.commit('setName', eventname)
    },
    getSectionsAction(context, raceId) {
        axios.get(`${process.env.VUE_APP_ROOT}/laravel/public/api/v1/promoter/section/${raceId}`).then((response) => {
            context.commit('setSections', response.data.sections);
            context.commit('setRace', response.data.race);
            context.commit('setClasses', response.data.classes);
        });
    },
    addSectionCheckUpdateAction(context, params) {
        const { field, value, sectionId } = params;
        let sectionsUpdate = context.state.sectionsUpdate;
        let indexSectionUpdate = sectionsUpdate.findIndex((sectionUpdate) => sectionUpdate.sectionId == sectionId);
        if(indexSectionUpdate >= 0) {
            sectionsUpdate[indexSectionUpdate][field] = value;
        } else {
            let sectionUpdate = {
                sectionId: sectionId
            };
            sectionUpdate[field] = value;
            sectionsUpdate.push(sectionUpdate);
        }
        context.commit('setSectionsUpdate',sectionsUpdate);
    },
    addSectionChecksInOutUpdateAction(context, params) {
        const { field, value, sectionId, checkId } = params;
        let sectionsUpdate = context.state.sectionsUpdate;
        let indexSectionUpdate = sectionsUpdate.findIndex((sectionUpdate) => sectionUpdate.sectionId == sectionId);
        if(indexSectionUpdate >= 0) {
            let indexCheckUpdate = (sectionsUpdate[indexSectionUpdate].raceSectionChecks || []).findIndex((el) => el.checkId == checkId);
            if(indexCheckUpdate >= 0) {
                sectionsUpdate[indexSectionUpdate].raceSectionChecks[indexCheckUpdate][field] = value;
            } else {
                let checkUpdate = {
                    checkId: checkId
                };
                checkUpdate[field] = value;
                if(!sectionsUpdate[indexSectionUpdate].raceSectionChecks && !Array.isArray(sectionsUpdate[indexSectionUpdate].raceSectionChecks)) {
                    sectionsUpdate[indexSectionUpdate].raceSectionChecks = [];
                }
                sectionsUpdate[indexSectionUpdate].raceSectionChecks.push(checkUpdate);
            }
        } else {
            let sectionUpdate = {
                sectionId: sectionId,
                raceSectionChecks: [ { checkId: checkId } ]
            };
            sectionUpdate.raceSectionChecks[0][field] = value;
            sectionsUpdate.push(sectionUpdate);
        }
        context.commit('setSectionsUpdate',sectionsUpdate);
    },
    addSectionCheckPenaltiesUpdateAction(context, params) {
        const { field, value, sectionId, checkId, penaltyId } = params;
        let sectionsUpdate = context.state.sectionsUpdate;
        let indexSectionUpdate = sectionsUpdate.findIndex((sectionUpdate) => sectionUpdate.sectionId == sectionId);
        if(indexSectionUpdate >= 0) {
            let indexCheckUpdate = (sectionsUpdate[indexSectionUpdate].raceSectionChecks || []).findIndex((el) => el.checkId == checkId);
            if(indexCheckUpdate >= 0) {
                let indexPenaltyUpdate = (sectionsUpdate[indexSectionUpdate].raceSectionChecks[indexCheckUpdate].penalties || []).findIndex((el) => el.penaltyId == penaltyId);
                if(indexPenaltyUpdate >= 0) {
                    sectionsUpdate[indexSectionUpdate].raceSectionChecks[indexCheckUpdate].penalties[indexPenaltyUpdate][field] = value;
                } else {
                    let penaltyUpdate = {
                        penaltyId: penaltyId
                    };
                    penaltyUpdate[field] = value;
                    if(
                        !sectionsUpdate[indexSectionUpdate].raceSectionChecks[indexCheckUpdate].penalties && 
                        !Array.isArray(sectionsUpdate[indexSectionUpdate].raceSectionChecks[indexCheckUpdate].penalties)
                    ) {
                        sectionsUpdate[indexSectionUpdate].raceSectionChecks[indexCheckUpdate].penalties = [];
                    }
                    sectionsUpdate[indexSectionUpdate].raceSectionChecks[indexCheckUpdate].penalties.push(penaltyUpdate);
                }
            } else {
                let checkUpdate = {
                    checkId: checkId,
                    penalties: [ { penaltyId: penaltyId } ]
                };
                checkUpdate.penalties[0][field] = value;
                if(!sectionsUpdate[indexSectionUpdate].raceSectionChecks && !Array.isArray(sectionsUpdate[indexSectionUpdate].raceSectionChecks)) {
                    sectionsUpdate[indexSectionUpdate].raceSectionChecks = [];
                }
                sectionsUpdate[indexSectionUpdate].raceSectionChecks.push(checkUpdate);
            }
        } else {
            let sectionUpdate = {
                sectionId: sectionId,
                raceSectionChecks: [ { checkId: checkId, penalties: [ { penaltyId: penaltyId } ] } ]
            };
            sectionUpdate.raceSectionChecks[0].penalties[0][field] = value;
            sectionsUpdate.push(sectionUpdate);
        }
        context.commit('setSectionsUpdate',sectionsUpdate);
    },
    addSectionTimeCheckUpdateAction(context, params) {
        context.dispatch('addSectionCheckUpdateAction', params);
    },
    addSectionTimeCheckCheckUpdateAction(context, params) {
        context.dispatch('addSectionChecksInOutUpdateAction', params);
    },
    addSectionTimeCheckPenaltyUpdateAction(context, params) {
        context.dispatch('addSectionCheckPenaltiesUpdateAction', params);
    }
}

export default {
 state, getters, mutations, actions
}
